<script setup>
//@ts-check
import HeaderArea from '../HeaderArea/HeaderArea.vue'
import HeaderAreaSimple from '../HeaderArea/HeaderAreaSimple.vue'
defineProps({
  mode: {
    type: String,
    required: false,
  },
})
const isApp = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_app'))?.value ?? '0'
</script>

<template>
  <template v-if="isApp == '0'">
    <HeaderAreaSimple v-if="mode == 'simple'" />
    <HeaderArea v-else />
  </template>
  <slot></slot>
</template>
